<template>
    <div class="px-md-12 pt-6" data-testid="data-collection" id="data-collection-form-wrapper">
        <v-divider />

        <span class="lock-icon">
            <v-icon small color="black" class="lock">
                fas fa-lock
            </v-icon>
        </span>
        <p tabindex="0">
            <strong
                :aria-label="$i18n.t('privacy.title')"
            >
                {{ $i18n.t('privacy.title') }}
            </strong><br />
            <span
                :aria-label="$i18n.t('privacy.text')"
            >
                {{ $i18n.t('privacy.text') }}
            </span>
        </p>
        <data-collection @closeForm="nextStep" />
    </div>
</template>
<script>
import DataCollection from '@/components/forms/DataCollection';
export default {
    name: 'step-data-collection-form',
    components: {
        DataCollection,
    },
    methods: {
        nextStep() {
            this.$emit('nextStep');
        },
    },
};
</script>

<style lang="scss" scoped>
#data-collection-form-wrapper {
    position: relative;
}
.lock-icon {
    text-align: center;
    border: 1px solid #000;
    position: absolute;
    right: 50%;
    top: 10px;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    background-color: white;

}
p {
    text-align: center;
    padding: 30px 0 40px 0;
    display:block;
}
strong {
    font-weight: bolder;
}
</style>
